import { render } from "./DesignerApplication.vue?vue&type=template&id=c52e0762&scoped=true"
import script from "./DesignerApplication.vue?vue&type=script&lang=js"
export * from "./DesignerApplication.vue?vue&type=script&lang=js"

import "./DesignerApplication.vue?vue&type=style&index=0&id=c52e0762&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c52e0762"]])

export default __exports__